/*
 * @Descripttion:
 * @version:
 * @Author: wl
 * @Date: 2020-05-29 09:10:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-23 14:27:55
 */

export default {
    sign: {
        video: '/playUrl/video' // 后端视频接口
    },
    // 图片请求头
    headurl: 'http://117.78.7.31:8000',
    //照片资源相关接口
    // http://192.168.1.111:8000/addImg
    // 图片地址
    imgURL:'http://117.78.7.31:8000/getImg/',
    // imgURL:'http://192.168.1.111:8000/getImg/',


    // imgURL:'http://192.168.1.111:8000/addImg',

    // 小区
    // img:'/getImg/img/',
    // 人员头像
    avatars:'/getImg/avatar/',
    // 通行类型
    pic:'pic/',
    avatar: {
        imageAvatar: '/imageAvatar/' //头像资源
        ,
        imagePic: '/imagePic' //通行识别头像资源
    },
    // 小区照片
    avatarXiaoqu: {
        image: '/image/community/' //小区资源

    },
    // 房屋配置
    build:{
        buildingList:'/admin/service/buildingList',            //小区列表
        buildingBatchAdd:'/admin/service/buildingBatchAdd',    //新建小区
    },


    // 人员管理
    personnel: {
        oneHousehold: "/admin/service/oneHousehold_OneFile",   // 一户一档
        personList: "/admin/service/personList",     //人员列表
        markUpdat: "/admin/service/markUpdat"   ,     //人员标记
        personControlList: "/admin/service/personControlList",     //人员布控
        personControlUpdate:"/admin/service/personControlUpdate",               //人员布增删改查
    },
    // 通行管理
    pass:{
        personUpdate: "/admin/service/personUpdate",   //人员修改
        personReview:"/admin/service/personReview",       //人员审核
        passList: "/admin/service/passList",              //人员通行
    },
    // 平台录入
    platFormEntry: {
        addPerson: "/admin/service/personAdd",   //人员添加
        // addPerson: "/admin/service/SpecialAdd",   //特殊人员添加
        personUpdate: "/admin/service/personUpdate",      // 人员修改

    },
    // 人员管理



}



// WEBPACK FOOTER //
// ./src/api/ports.js